import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  List,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Upload,
} from "antd";
import "./DetailDiagnose.scss";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import { FORMAT_TIME, TEN_PHONG, tabKeys } from "types/enums";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";

import PatientInfo, { PatientInfoRef } from "./PatientInfo/PatientInfo";
import diagnose from "api/diagnose";
import Notification from "components/common/notification/notification";
import {
  setDataDiagnose,
  setIsCallResultDiagnose,
} from "redux/reducer/diagnose";
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Cancel,
  Completed,
  Pause,
  SaveAndPrint,
} from "pages/Refractive/InforDetails/config";
import dayjs from "dayjs";
import { allColumns } from "./config";
import { StepInfo } from "components/common";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import PdfViewer from "./PdfViewer/PdfViewer";
import axiosClient from "api/axiosClient";
import {
  convertDateStringToDateTimezone_7,
  dispatchCurrentRoom,
  formatDateOrStringToStringGMT_7,
} from "helper/common";
import DiagnoseModal from "components/common/PrintReceipt/DiagnoseModal/DiagnoseModal";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { ColumnsEdit } from "types/models/column-table-edit";

const DetailPatient = () => {
  const detailDiagnose = useAppSelector((e) => e.diagnose.data);

  const [listButton, setListButton] = useState<any[]>([]);
  const [dataTable, setDataTable] = useState([]);

  const dispatch = useAppDispatch();
  const activeKey = useAppSelector((state) => state.common.activeTab);
  const idDiagnose = useAppSelector((e) => e.diagnose.idDiagnose);

  const modalRef = useRef<any>();
  const modalViewer = useRef<any>();
  const diagnoseRef = useRef<PatientInfoRef | null>(null);
  const diagnosePrintRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [idTable, setIdTable] = useState<number>(null);
  const [fileList, setFileList] = useState<any[]>([]);
  const [columns, setColumns] = useState<ColumnsEdit>(allColumns);
  const [filePdf, setFilePdf] = useState<File | string | object>({});
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const [form] = Form.useForm();

  const getDetailsDiagnose = async () => {
    if (idDiagnose !== null) {
      setLoading(true);
      try {
        const res = await diagnose.getDetailsDiagnoseById(idDiagnose);
        dispatchCurrentRoom(
          dispatch,
          res?.trangThai,
          TEN_PHONG.phong_chup_mi_mat
        );
        const newData = res.listChiDinhCDHA.map((e) => ({
          ...e,
          key: e.id,
          isStart: false,
          thoiGianBatDau: convertDateStringToDateTimezone_7(e.thoiGianBatDau),
          thoiGianKetThuc: convertDateStringToDateTimezone_7(e.thoiGianKetThuc),
        }));

        setDataTable(newData);
        form.setFieldValue("chuanDoan", newData);

        dispatch(setIdPhieuKham(res.idPhieuKham));
        if (res?.trangThai === 1) {
          const newRes = postStatusDiagnoseForm(2, "", false);
          dispatch(setDataDiagnose(newRes));
        } else dispatch(setDataDiagnose(res));

        setLoading(false);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else Notification("error", "Chưa có thông tin phiếu khám");
  };

  const getList = async () => {
    setLoadingFile(true);
    if (idTable !== null) {
      try {
        const res = await diagnose.getListFiles(idTable);
        const newRes = res.map((item) => {
          return {
            ...item,
            fileKetQua: getDesiredFileName(item.fileKetQua),
          };
        });
        setLoadingFile(false);

        setFileList(newRes);
      } catch (error) {
        Notification("error", "Lỗi khi lấy file");
        setLoadingFile(false);
      }
    }
  };
  //xử lý tên khi lấy danh sách
  const getDesiredFileName = (fileName: string) => {
    const fileNameParts = fileName.split("-");
    const desiredFileName = fileNameParts.slice(5).join("-");
    return desiredFileName;
  };

  const onChangePagination = (page, pageSize) => {
    setParams({ page: page, limit: pageSize });
  };
  useEffect(() => {
    getList();
  }, [idTable]);
  useMemo(() => {
    if (idDiagnose === null) {
      dispatch(setActiveKey(tabKeys.DIAGNOSE.LIST_PATIENT));
    }
  }, []);

  const handlePreview = async (record) => {
    try {
      modalViewer.current?.openModal();
      const url = `/qlkhambenh/chi-dinh-cdha/show-file-ket-qua?ids=${record.id}`;
      const res = await axiosClient.get(url, { responseType: "blob" });
      const data = res.data;
      setFilePdf(data);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xem tệp");
    }
  };

  const handleDelete = async (item) => {
    setLoadingFile(true);
    try {
      await diagnose.deletefiles(item.id);
      getList();
      setLoadingTable;
    } catch (error) {
      setLoadingFile(false);
      Notification("error", "Xóa file không thành công");
    }
  };

  const postStatusDiagnoseForm = async (trangThai, name, dis) => {
    setLoading(true);
    try {
      const params = {
        id: idDiagnose,
        trangThai: trangThai,
      };
      const res = await diagnose.updateStatusDiagnose(params);
      dispatch(setIdPhieuKham(res.idPhieuKham));
      dispatch(setDataDiagnose(res));

      setLoading(false);
      if (trangThai != 2) {
        Notification("success", `Cập nhật trạng thái ${name} thành công`);
      }
      dis && dispatch(setActiveKey(tabKeys.DIAGNOSE.LIST_PATIENT));
    } catch (error) {
      setLoading(false);

      Notification("error", `Cập nhật trạng thái ${name} thành công`);
    }
  };

  const changeStatusDetailDiagnose = async (status) => {
    setLoading(true);
    try {
      const data = diagnoseRef.current?.getFormValue();

      const newData = {
        ...detailDiagnose,
        ...data,
        ngayTao: detailDiagnose?.ngayTao,
        thoiGianChiDinh: data?.thoiGianChiDinh._i,
        id: idDiagnose,
        trangThai: status,
        thoiGianHoanThanh: dayjs().format(),
        listChiDinhCDHA: form.getFieldValue("chuanDoan"),
      };
      // const disableButton = disableBtn(newData.ngayTao);
      // if (disableButton) {
      //   modalAlertRef.current.openModal();
      //   setLoading(false);
      //   return;
      // }
      const res = await diagnose.updateDetails(newData);

      dispatch(setDataDiagnose(res));

      setLoading(false);

      Notification("success", "Đã cập nhật phiếu thành trạng thái hoàn thành");
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  const handleStart = async (id) => {
    for (const item of dataTable) {
      if (item.id === id) {
        // Update the state with the new 'dataTable'
        setDataTable((prevDataTable) => {
          return prevDataTable.map((prevItem) =>
            prevItem.id === id
              ? {
                  ...prevItem,
                  isStart: true,
                  thoiGianBatDau: dayjs(),
                }
              : prevItem
          );
        });
      }
    }
  };

  const handleEnd = (id) => {
    for (const item of dataTable) {
      if (item.id === id) {
        setDataTable((prevDataTable) => {
          return prevDataTable.map((prevItem) =>
            prevItem.id === id
              ? {
                  ...prevItem,
                  isStart: false,
                  thoiGianKetThuc: dayjs(),
                }
              : prevItem
          );
        });
      }
    }
  };

  const customRequest = async (options: any) => {
    // Gửi yêu cầu POST tới máy chủ
    setLoadingTable(true);
    const file_size = options.file.size;
    try {
      if (file_size <= 3000000) {
        // Tạo một FormData để gửi tệp lên máy chủ
        const formData = new FormData();
        formData.append("pdfFiles", options.file as Blob);

        await diagnose.uploadFileResultDiagnose(idTable, formData);
        setLoadingTable(false);
        getList();
        Notification("success", "Đã tải file thành công");
      } else {
        setLoadingTable(false);
        Notification("warning", "Kích thước file vượt quá giới hạn (3MB)");
      }
    } catch (error) {
      setLoadingTable(false);
      Notification(
        "error",
        "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
      );
    }
    return false;
  };

  const handleDownload = async (item) => {
    try {
      const res = await diagnose.getDetailFile(item.id);

      const link = document.createElement("a");

      link.href = res;
      link.target = "_blank";
      link.click();
    } catch (error) {
      Notification("error", error);
    }
  };

  const handleComplete = async () => {
    changeStatusDetailDiagnose(3);
  };

  useEffect(() => {
    if (dataTable) {
      // const newDiag = {
      //   ...detailDiagnose,
      //   listChiDinhCDHA: dataTable,
      // };
      dispatch(
        setDataDiagnose({
          ...detailDiagnose,
          listChiDinhCDHA: dataTable,
        })
      );
    }
  }, [dataTable]);

  useEffect(() => {
    setDataTable(detailDiagnose?.listChiDinhCDHA);
  }, [detailDiagnose]);

  const handlePause = async () => {
    if (detailDiagnose?.trangThai == 2) {
      await postStatusDiagnoseForm(1, "chờ thực hiện", true);
    } else {
      Notification(
        "warning",
        "Chỉ tạm dừng khi phiếu ở trạng thái Đang thực hiện"
      );
    }
  };

  const handleCancel = async () => {
    await postStatusDiagnoseForm(6, "hủy thực hiện", true);
  };

  const handleSave = async (record, id) => {
    try {
      const newValue = {
        id: id,
        ...record,
      };
      await diagnose.updateDetailsTable(newValue);
      getDetailsDiagnose();
      Notification("success", "Cập nhật dữ liệu thành công");
    } catch (error) {
      Notification("error", "Cập nhật dữ liệu thất bại");
    }
  };

  // const handleGhiChu = (v, i) => {
  //   const positionValue = dataTable.map((e) => {
  //     if (e.id === i) {
  //       return {
  //         ...e,
  //         ghiChu: v,
  //       };
  //     }
  //     return e;
  //   });
  //   setDataTable(positionValue);
  // };

  columns?.map((item) => {
    if (item.dataIndex === "actions") {
      item.render = (text, record: { id: any; isStart: boolean }, i) => {
        return (
          <Space split={<Divider type="horizontal" />}>
            {!record.isStart ? (
              <Tooltip title={"Bắt đầu"}>
                <Button
                  onClick={() => handleStart(record.id)}
                  type="default"
                  icon={<PlayCircleOutlined />}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Kết thúc">
                <Button
                  onClick={() => handleEnd(record.id)}
                  icon={<PauseCircleOutlined />}
                />
              </Tooltip>
            )}
            <Tooltip title="Tải file">
              <Button
                onClick={() => {
                  setIdTable(record.id);
                  modalRef.current?.openModal();
                }}
                icon={<UploadOutlined />}
              />
            </Tooltip>
            <Tooltip title="Lưu dữ liệu">
              <Button
                onClick={() =>
                  handleSave(form?.getFieldValue(["chuanDoan", i]), record.id)
                }
                icon={<SaveOutlined />}
              />
            </Tooltip>
          </Space>
        );
      };
    }

    if (item.dataIndex === "stt") {
      item.render = (t, r, i) => {
        return (params.page - 1) * params.limit + i + 1;
      };
    }
  });

  const getListDiagnoseMachines = async () => {
    try {
      const res = await diagnose.getListMayCDHA();

      const options = await res.map((item) => {
        return { value: item.id.toString(), label: item.tenMayCDHA };
      });
      columns.find((e) => e.dataIndex === "mayXetNghiem").options = options;
      setColumns([...columns]);
    } catch (error) {
      console.log("🚀 ~ getListDiagnoseMachines ~ error:", error);
      Notification("error", "Lấy danh sách máy CĐHA thất bại");
    }
  };

  const handlePrint = () => {
    diagnosePrintRef.current.openModal();
    dispatch(setIsCallResultDiagnose(true));
  };

  // useEffect(() => {
  //   if (activeKey === tabKeys.DIAGNOSE.DETAIL_INFO) {
  //     getListDiagnoseMachines();
  //   }
  // }, [idDiagnose, activeKey]);

  useEffect(() => {
    if (activeKey != tabKeys.DIAGNOSE.DETAIL_INFO) {
      dispatch(setButtonsHeader([]));
    } else {
      getDetailsDiagnose();
      getListDiagnoseMachines();
      dispatch(setButtonsHeader(listButton));
    }
  }, [activeKey]);

  useEffect(() => {
    if (listButton.length > 0 && activeKey == tabKeys.DIAGNOSE.DETAIL_INFO) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [listButton]);

  // useEffect(() => {
  //   if (activeKey == tabKeys.DIAGNOSE.DETAIL_INFO) {
  //   }
  // }, [activeKey]);

  useEffect(() => {
    setListButton([
      SaveAndPrint(handlePrint, "In phiếu"),
      Completed(handleComplete, "Hoàn thành CĐHA"),
      // NextPatient(handleNextPatient),
      Cancel(handleCancel),
      Pause(handlePause),
    ]);
  }, [detailDiagnose]);
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);

  // const getFormValues = async () => {
  //   try {
  //     const formValues = await form.validateFields();
  //     console.log("🚀 ~ getFormValues ~ formValues:", formValues);
  //     return formValues?.chuanDoan;
  //   } catch (error) {
  //     return null;
  //   }
  // };
  return (
    <Spin spinning={loading}>
      <div className="detail-diagnose">
        <div className="container">
          <div className="header">Thông tin bệnh nhân</div>
          <div className="container-main">
            <PatientInfo detailDiagnose={detailDiagnose} ref={diagnoseRef} />
          </div>
        </div>

        <div className="container">
          <StepInfo />
        </div>

        <div className="container">
          <Spin spinning={loadingTable}>
            <div className="header">Thông tin CĐHA</div>
            {/* <Table
              columns={allColumns}
              dataSource={dataTable}
              bordered
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: total,
                onChange: onChangePagination,
              }}
              scroll={{ x: "100%" }}
            /> */}
            <Form form={form}>
              <TableInputAdd
                data={dataTable}
                setData={setDataTable}
                column={columns}
                name="chuanDoan"
                form={form}

                // setTongTien={_setTongTien}
              />
            </Form>
          </Spin>
        </div>
      </div>
      {/* Modal tải kết quả lên */}
      <ModalCustom ref={modalRef} title={"Danh sách kết quả"}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Spin spinning={loadingFile}>
            <Row style={{ fontSize: "20px", fontWeight: "bold" }}>
              Tên tệp đã tải lên
            </Row>
            <List
              className="list-item"
              dataSource={fileList}
              renderItem={(item) => (
                <List.Item
                  style={{ padding: "10px 0" }}
                  actions={[
                    <Tooltip title="Tải xuống">
                      <Button
                        icon={<DownloadOutlined />}
                        onClick={() => handleDownload(item)}
                      />
                    </Tooltip>,

                    <Tooltip title="Xem chi tiết">
                      <Button
                        icon={<EyeOutlined />}
                        onClick={() => handlePreview(item)}
                      />
                    </Tooltip>,
                    <Tooltip title="Xóa">
                      <Button
                        type="default"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(item)}
                      />
                    </Tooltip>,
                  ]}
                >
                  <List.Item.Meta title={item.fileKetQua} />
                </List.Item>
              )}
            />
            <Row justify={"end"} gutter={[16, 16]}>
              <Col>
                <Upload
                  customRequest={customRequest}
                  accept=".pdf"
                  multiple
                  showUploadList={false}
                >
                  <Tooltip title="Tải file lên(tối đa 3Mb)">
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<UploadOutlined />}
                    >
                      Tải tệp lên từ máy tính
                    </Button>
                  </Tooltip>
                </Upload>
              </Col>
              <Button
                type="default"
                danger
                onClick={() => modalRef.current?.closeModal()}
              >
                Hủy bỏ
              </Button>
            </Row>
          </Spin>
        </Space>
      </ModalCustom>
      <PdfViewer modalViewer={modalViewer} filePdf={filePdf} />
      <div onBlur={() => dispatch(setIsCallResultDiagnose(false))}>
        <ModalCustom
          wrapClassName="modal-print-form"
          ref={diagnosePrintRef}
          centered
          width={1000}
        >
          <DiagnoseModal />
        </ModalCustom>
      </div>
      {/* Cảnh báo quá hạn ngày */}
      {/* <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom> */}
    </Spin>
  );
};
export default DetailPatient;
